import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { WallboardViewService } from '../wallboard-view.service';
import { SummaryModuleDataApiModel, WVCustom, WVMain } from '../wallboard-view.model';
import { SummarySettingsTransferObj, ModuleType } from '../../wallboards.model';

@Component({
    selector: 'cv-wallboard-view-custom-summary',
    templateUrl: './wallboard-view-custom-summary.component.html',
    styleUrls: ['./wallboard-view-custom-summary.component.scss']
})
export class WallboardViewCustomSummaryComponent implements OnInit, OnDestroy {
    @Input() height;
    @Input() index;
    @Input() firstSlide;

    public wvf: WVMain;
    public wvcf: WVCustom;
    public summaryState: SummarySettingsTransferObj;
    public summaryData: SummaryModuleDataApiModel;
    public summaryMetricNames: string[] = [];

    public slideError: boolean = false;
    private tableHeight: number = 0;

    private updateTimerRef: NodeJS.Timeout = null;
    private isDestroyed: boolean = false;
    private _hasBackdrop: boolean = false;
    private _moduleKey: string = "";

    get hasBackdrop(): boolean {
        return this._hasBackdrop;
    }

    get moduleKey(): string {
        return this._moduleKey;
    }
    constructor(
        private service: WallboardViewService
    ) { }

    ngOnInit(): void {
        this.wvf = this.service.WVMain;
        this.wvcf = this.service.WVCustom;

        this._hasBackdrop = this.wvcf?.Slide.HasBackdrop ?? false;
        this._moduleKey = this.wvcf?.Slide.WallboardModuleDetails[this.index].WallboardModuleKey ?? "";

        const summaryContainer = angular.element(document).children().first();
        summaryContainer.css("height", this.height);
        this.tableHeight = summaryContainer.height() - 132;

        let moduleState = this.service.loadModuleState(ModuleType.SummaryModule, this.wvf.WallboardCreatorID, this.moduleKey).then(response => {
            if (this.isDestroyed)
                return;

            this.summaryState = response.sumObj;
        });

        let summaryModuleData = this.service.getSummaryModuleData(this.wvcf.Slide.WallboardID, Math.floor(this.tableHeight / 60), false, false, this.moduleKey).then(response => {
            if (this.isDestroyed)
                return;

            this.summaryData = response;
        });

        this.service.getSummaryMetricNames(this.wvcf.Slide.WallboardID, this.moduleKey).then(response => {
            if (this.isDestroyed)
                return;

            this.summaryMetricNames = response;
        });

        Promise.all([moduleState, summaryModuleData]).then(responses => {
            if (!this.firstSlide) {
                let dup = false;

                for (let i = 0; i < this.wvcf.ReadyModules.length - 1; i++) {
                    if (this.moduleKey === this.wvcf.ReadyModules[i]) {
                        dup = true;
                        break;
                    }
                }

                if (!dup)
                    this.wvcf.ReadyModules.push(this.moduleKey);
            }

            if (!this.updateTimerRef) {
                const refreshInterval = this.summaryData.Has_Current_Metric
                    ? WallboardViewService.REALTIME_DATA_REFRESH_INTERVAL
                    : WallboardViewService.HISTORICAL_DATA_REFRESH_INTERVAL;
    
                this.updateTimerRef = setInterval(() => this.updateSlideData(), refreshInterval);
            }
        });
    }

    ngOnDestroy(): void {
        // End data updates
        if (this.updateTimerRef != null)
            clearInterval(this.updateTimerRef);

        this.isDestroyed = true;
    }

    async updateSlideData() {
        if (this.isDestroyed)
            return;

        let response = await this.service.getSummaryModuleData(this.wvcf.Slide.WallboardID, Math.floor(this.tableHeight / 60), false, false, this.moduleKey);

        if (this.isDestroyed)
            return;

        this.summaryData = response;
    }
}
